export enum ProductBundleStyleType {
  POST_PURCHASE_PRODUCT_BUNDLE = 'POST_PURCHASE_PRODUCT_BUNDLE',
  MANUAL_SOP_PRODUCT_BUNDLE = 'MANUAL_SOP_PRODUCT_BUNDLE',
}

export enum BG_COLOR {
  TRANSPARENT = 'transparent',
}
